import { useState } from "react";
import { Set, Get } from "../../../../../Request";

export const useComment = () => {
  const [loading, setLoading] = useState({
    list: true,
  });
  const [modal, setModal] = useState({
    visible: false,
  });
  const [list, setList] = useState([]);
  const getList = async data => {
    setLoading({ ...loading, list: true });
    Get({
      url: "/order/wait_comment",
      data: { rel_type: "User" },
    }).then(res => {
      setList(res);
      setLoading({ ...loading, list: false });
    });
  };
  return {
    loading,
    getList,
    list,
    modal,
    setModal,
  };
};
export const useSubmitedComment = () => {
  const [loading, setLoading] = useState({
    list: true,
  });
  const [list, setList] = useState([]);
  const getList = async () => {
    setLoading({ ...loading, list: true });
    Get({
      url: "/comment/user",
    }).then(res => {
      setList(res);
      setLoading({ ...loading, list: false });
    });
  };
  return {
    loading,
    getList,
    list,
  };
};
export const useSubmitComment = () => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    rel_type: "item",
  });
  const sendComment = async data => {
    setLoading(true);
    Set({
      url: "/comment/create",
      data: { ...data, ...form },
    }).then(res => {
      setLoading(false);
    });
  };
  return {
    loading,
    sendComment,
    form,
    setForm,
  };
};
